
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/partido/[slug]/estadisticas-la-liga-fantasy-en-vivo",
      function () {
        return require("private-next-pages/partido/[slug]/estadisticas-la-liga-fantasy-en-vivo.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/partido/[slug]/estadisticas-la-liga-fantasy-en-vivo"])
      });
    }
  